export const isMocks =
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_TARGET === 'mocks'
